import { Select } from "../../ui/Select";
import { Input } from "../../ui/Input";
import { RadioGroup } from "../../ui/RadioGroup";
import { SubHead } from "../../ui/SubHead";
import { yesNoOption, getClientTypeOptions } from "../../options/options";
import { SearchableSelect } from "../../ui/SearchableSelectReact";
import { useEffect, useState, useRef } from "react";
import { CompanyVerificationModal } from "./CompanyVerificationModal";
import { matchCompanyType } from "../../../utils/matchCompanyType";
export const ClientCounterpartyForm = ({
    isReport,
    isSelectorReadOnly,
    formData,
    step,
    existingEntity,
    companyType,
    transactionId,
    transactionType,
    isRegulatoryListed,
    isBillingEntityListed,
    isReadOnly,
    countries,
    regulatoryBodies,
    exchanges,
    sendMail,
    showModal,
    modalMessage,
    setShowModal,
    handleChange,
    handleBillingEntityChange,
    handleMoneyChange,
    handleentityChange,
    handleCountryChange,
    handleEntityChanged,
    handleRegulatoryChange,
    handleSubmit,
    handleUpdate,
}) => {
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [showGuarantorModal, setShowGuarantorModal] = useState(false);
    const prevEntityTypeRef = useRef(formData.entityType);

    // Show guarantor modal when entityType changes to "Guarantor"
    useEffect(() => {
      if (formData.entityType === "Guarantor" && prevEntityTypeRef.current !== "Guarantor") {
        setShowGuarantorModal(true);
      }
      prevEntityTypeRef.current = formData.entityType;
    }, [formData.entityType]);

    const [companyLookupData, setCompanyLookupData] = useState({
      companyName: "",
      registrationNumber: "",
      countryOfIncorporation: "",
      companyType: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      state: "",
      postCode: "",
    });

    const handleFromCommpanyLookupModal = (data) => {
      console.log("Data from CompanyVerificationModal:", data);
      if (data.companyType) {
        const matched = matchCompanyType(data.companyType, companyType);
        data = { ...data, companyType: matched || "" };
      }
      setCompanyLookupData(data);
    }

    useEffect(() => {
      console.log("companyLookupData changed:", companyLookupData);
      if (companyLookupData && companyLookupData.companyName) {
        setShowVerificationModal(false);

        const mapCompanyLookupKeysToFormDataKeys = {
          companyName: "companyName",
          registrationNumber: "registrationNumber",
          countryOfIncorporation: "countryOfIncorporation",
          companyType: "companyType",
          addressLine1: "addressLine1",
          addressLine2: "addressLine2",
          addressLine3: "addressLine3",
          city: "city",
          state: "state",
          postCode: "postCode",
          overseasEntities: "overseasEntities",
          overseasEntitiesNumber: "overseasEntitiesNumber",
        };

        for (const [lookupKey, formKey] of Object.entries(mapCompanyLookupKeysToFormDataKeys)) {
          if (companyLookupData[lookupKey] !== undefined && companyLookupData[lookupKey] !== null) {
            handleChange({
              target: {
                name: formKey,
                value: companyLookupData[lookupKey] || "",
              },
            });
          }
        } 
        }
    }, [companyLookupData, handleChange]);

    return (
        <div className="transaction-form">
           
            <form>
              <div className="top-section">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', }} >
              <h2 style={{ margin: 0 }}>Client/Counterparty Due Diligence</h2>
               {/* <button
          type="button"
          onClick={() => setShowVerificationModal(true)}
          style={{
            background: "#07b1b0",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            color: "#fff",
            padding: "10px",
            borderRadius:"10px"
          }}
          title="Verify Company"
        >
          Company Lookup
        </button> */}
            </div>
            {/* {showVerificationModal && (
        <CompanyVerificationModal onClose={() => setShowVerificationModal(false)} />
      )} */}
       {showVerificationModal && (
        <CompanyVerificationModal onClose={() => setShowVerificationModal(false)} onSend={handleFromCommpanyLookupModal} />
      )}
 {!isReport && <Select
              label="Quick Fill Existing Entity:"
              name="entityId"
              onChange={handleEntityChanged}
              value={formData.entityId}
              disabled={isSelectorReadOnly || isReadOnly}
              options={
                existingEntity && existingEntity.length > 0 
                  ? existingEntity
                    .filter((value) => value != null)
                    .map((value) => parseInt(value))
                    .sort((a, b) => b - a)
                    .map((value) => ({
                      value,

                      
                      display_value: `Entity Id: ${value}`
                    }))
                  : ["No Entity avaliable"]
              } />}

              <Input
                label="Entity ID"
                type="text"
                name="entityId"
                placeholder={"Auto Generated"}
                value={
                  typeof formData.entityId === "object"
                    ? formData.entityId?.id?.toString?.() ?? ""
                    : formData.entityId?.toString?.() ?? ""
                }
                onChange={handleEntityChanged}
                disabled={true}
                isReport={isReport}
              />

              <Input
                label="Entity Status"
                type="text"
                name="entityStatus"
                value={formData.entityStatus} // [ ] change status to entityStatus
                onChange={handleEntityChanged}
                disabled={true}
                isReport={isReport}
              />

              <Input
                label="Client reference number"
                type="text"
                name="clientReferenceNumber"
                value={formData.clientReferenceNumber}
                onChange={handleChange}
                disabled={isReadOnly}
                isReport={isReport}
              />

              </div>
           <div className="bottom-section">
              {
                <RadioGroup
                  label="What involvement does the entity have in the transaction?"
                  name="clientType"
                  value={formData.clientType}
                  disabled={isReadOnly}
                  required={true}
                  onChange={handleChange}
                  isReport={isReport}
                  options={getClientTypeOptions(transactionType, transactionId)}
                />
              }

            <RadioGroup
              label="Select the Entity Role"
              name="entityType"
              value={formData.entityType}
              onChange={handleChange}
              disabled={isReadOnly}
              isReport={isReport}
              required={true}
              options={[
                { value: "Client", display_value: "Client" },
                { value: "Counterparty", display_value: "Counterparty" },
                { value: "Guarantor", display_value: "Guarantor" }
              ]}
            />

            {formData.entityType === "Guarantor" && (
              <div className="form-group">
                <label>Provide Brief Details *</label>
                <textarea
                  name="guarantorBriefDetails"
                  value={formData.guarantorBriefDetails || ""}
                  onChange={handleChange}
                  disabled={isReadOnly}
                  required
                  rows="3"
                  placeholder="Provide brief details about the guarantor..."
                  style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                />
              </div>
            )}

            <div style={{ position: 'relative' }}>
              <Input
                label="Company Name"
                type="text"
                name="companyName"
                value={formData.companyName} // [ ] change from CompanyName to companyName
                onChange={handleChange}
                required={true}
                disabled={isReadOnly}
                isReport={isReport}
              />
              {!isReport && (
                <button
                  type="button"
                  onClick={() => setShowVerificationModal(true)}
                  disabled={isReadOnly}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    background: "#07b1b0",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#fff",
                    padding: "6px 12px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                  }}
                  title="Verify Company"
                >
                  Company Lookup
                </button>
              )}
            </div>
 
            <SearchableSelect
              label="Country of Incorporation"
              name="countryOfIncorporation"
              value={formData.countryOfIncorporation}
              onChange={handleCountryChange}
              required={true}
              disabled={isReadOnly}
              options={countries.map((value)=>({value,display_value:value}))}
              isReport={isReport}
            />

            <Select
              label="Company Type"
              name="companyType"
              value={formData.companyType}
              required={true}
              disabled={isReadOnly}
              onChange={handleChange}
              isReport={isReport}
              options={
                Array.isArray(companyType)
                ? companyType.map((value) => ({ value: value.CompanyType, display_value: value.CompanyType  }))
                : ["No Company Type Exists"]
              }
            />
            
            <Input
              label="Registration Number"
              name="registrationNumber"
              value={formData.registrationNumber} // [ ] later use only camel case
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
            />

            <Input
              label="Client Reference Number"
              type="text"
              name="clientReferenceNumber"
              value={formData.clientReferenceNumber || ""}
              onChange={handleChange}
              disabled={isReadOnly}
              isReport={isReport}
            />
            <h4 style={{margin:"10px 0", fontSize:"14px"}}>Registered Office</h4>

            <Input
              label=" Address Line 1"
              type="text"
              name="addressLine1"
              value={formData.addressLine1} // [ ] later use camel case
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
            />

            <Input
              label="Address Line 2"
              type="text"
              name="addressLine2"
              value={formData.addressLine2} // [ ] later use camel case
              onChange={handleChange}
              required={false}
              disabled={isReadOnly}
              isReport={isReport}
            />

            <Input
              label="Address Line 3"
              type="text"
              name="addressLine3"
              value={formData.addressLine3} // [ ] later use camel case
              onChange={handleChange}
              required={false}
              disabled={isReadOnly}
              isReport={isReport}
            />

           

            <Input
              label="City"
              type="text"
              name="city"
              value={formData.city} // [ ] later use small one
              onChange={handleChange}
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
            />
             <Input
              label="County/State"
              type="text"
              name="state"
              value={formData.state} // [ ] later use small one
              onChange={handleChange}
              disabled={isReadOnly}
              isReport={isReport}
            />

            <Input
              label="Postcode"
              type="text"
              name="postCode"
              onChange={handleChange}
              value={formData.postCode} // [ ] later use small one
              required={true}
              disabled={isReadOnly}
              isReport={isReport}
            />

            <RadioGroup 
              label="Is client listed on the Register of Overseas Entities?"
              required={true}
              name="overseasEntities" // [ ] later change to camel case
              onChange={handleentityChange}
              disabled={isReadOnly}
              value={formData.overseasEntities}
              options={yesNoOption}
              isReport={isReport}
            />

            {/* Conditional Display of Entity Number Input */}
            {(formData.OverseasEntities === "Yes" || formData.overseasEntities === "Yes") &&  
              <Input
              label="Registered Overseas Entities Number:"
              type="text"
              name="overseasEntitiesNumber"
              required={true}
              disabled={isReadOnly}
              onChange={handleChange}
              value={formData.overseasEntitiesNumber}
              isReport={isReport}
            />}


            {/* Question: Is Client Regulated? */}

            <RadioGroup 
              label="Is client regulated by a recognised regulatory body?"
              required={true}
              name="isRegulatoryListed"
              value={formData.isRegulatoryListed}
              onChange={handleRegulatoryChange}
              disabled={isReadOnly}
              options={yesNoOption}
              isReport={isReport}
            />

            {/* Conditional Display of Additional Fields */}
            {(formData.isRegulatoryListed === "Yes" || isRegulatoryListed) && (
              <>
                <Select
                  label="Select the regulatory body:"
                  name="regulatoryBody"
                  value={formData.regulatoryBody}
                  onChange={handleChange}
                  required={true}
                  disabled={isReadOnly}
                  isReport={isReport}
                  options={
                    regulatoryBodies.length > 0 
                    ? regulatoryBodies.map((value) => ({ 
                      value: value.RegulatoryAuthority, 
                      display_value: value.RegulatoryAuthority 
                    }))
                    : ["No regulatory bodies avaliable"]
                  }
                />
                <Input 
                  label="Enter regulatory reference number"
                  required={true}
                  name="regulatoryReferenceNumber"
                  value={formData.regulatoryReferenceNumber}
                  onChange={handleChange}
                  disabled={isReadOnly}
                  isReport={isReport}
                />
              </>
            )}

            {/* Question: Is Billing Entity Listed? */}
            <RadioGroup 
              label="Is Billing Entity listed on a recognised exchange?"
              required={true}
              name="isBillingRecognized"
              value={formData.isBillingRecognized}
              onChange={handleBillingEntityChange}
              disabled={isReadOnly}
              options={yesNoOption}
              isReport={isReport}
            />   
          
            {/* Conditional Display of Exchange Dropdown */}
            {(formData.isBillingRecognized === "Yes") && (
              <Select
              label="Select the recognised exchange:"
              name="recognisedExchange"
              value={formData.recognisedExchange}
              onChange={handleChange}
              disabled={isReadOnly}
              required={true}
              isReport={isReport}
              options={
                exchanges.length > 0
                ? exchanges.map((value) => ({
                  value: value.ExchangeName,
                  display_value: `${value.ExchangeName} (${value.Country})`
                }))
                : ["No exchanges available"]
              }
            />
            )}

{(formData.clientType === "Landlord" || formData.clientType === "Vendor") && (
  <RadioGroup 
    label="Do you have either an official copy from Land Registry or evidence from Datscha to confirm ownership of this property?"
    name="landRegisterCopy"
    value={formData.landRegisterCopy}
    disabled={isReadOnly}
    onChange={handleChange}
    options={yesNoOption}
    isReport={isReport}
  />
)}

            <SubHead text="Third-Party Reliance" isReport={isReport} />

            {/* Step 1: Are you taking reliance from a third party? */}
            <RadioGroup 
              label="1. Are you taking reliance from a third party?"
              required={true}
              name="relianceFromThirdParty"
              onChange={handleChange}
              value={formData.relianceFromThirdParty}
              disabled={isReadOnly}
              options={yesNoOption}
              isReport={isReport}
            />

            

            {/* Step 2: Do you already have a compliant letter of reliance? */}
            {(formData.relianceFromThirdParty === "Yes") && (
              <RadioGroup 
              label="2. Do you already have a compliant letter of reliance?"
              name="compliantLetter"
              value={formData.compliantLetter}
              onChange={handleChange}
              disabled={isReadOnly}
              options={yesNoOption}
              isReport={isReport}
            />
            )}

            

            {/* Step 3: Does your letter comply with Section 39? */}
            {(formData.compliantLetter === "Yes") && (
              <div className="form-group">
                <RadioGroup 
                isReport={isReport}
                  label="3. Does your letter comply with Section 39 of The Money
                      Laundering Regulations 2017?"
                  name="complyWithRegulations"
                  onChange={handleMoneyChange}
                  disabled={isReadOnly}
                  value={formData.complyWithRegulations}
                  options={yesNoOption}
                />
                {!isReport && <div className="instructions">
                  <p>
                    <strong>For compliance, the reliance provider must:</strong>
                  </p>
                  <ul>
                    <li>
                      Retain the underlying due diligence records for at least 5
                      years from the end of the transaction.
                    </li>
                    <li>
                      Undertake to provide these records immediately upon
                      request.
                    </li>
                  </ul>
                </div>}
                {/* Conditionally show buttons when "No" is selected */}
                {!isReport && (formData.complyWithRegulations === "No") && (
                  <div className="email_button-group">
                    <button type="button" onClick={() => sendMail("mlno")}>
                      Contact MLNO
                    </button>
                    <button type="button" onClick={() => sendMail("cod")}>
                      Contact COnD
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Third Party Information Form */}
            {(formData.complyWithRegulations === "Yes") && (
              <div className="third-party-form">
                <h3>
                  Please provide the following information about the third party:
                </h3>

                <Input
                  label="Name of entity you are taking reliance from:"
                  type="text"
                  name="entityName"
                  isReport={isReport}
                  value={formData.entityName}
                  onChange={handleChange}
                  disabled={isReadOnly}
                />

                <Select
                  label="Type of entity you are taking reliance from:"
                  name="ThirdPartyRelianceType"
                  value={formData.ThirdPartyRelianceType}
                  onChange={handleChange}
                  disabled={isReadOnly}
                  isReport={isReport}
                  options={[
                    { value: "Accountants or auditors", display_value: "Accountants or auditors" },
                    { value: "Regulated financial services firms", display_value: "Regulated financial services firms (e.g., banks, investment firms)" },
                    { value: "Estate agents", display_value: "Estate agents (supervised by HMRC)" },
                    { value: "Trust or company service providers", display_value: "Trust or company service providers" },
                    { value: "Regulated Fund Manager", display_value: "Regulated Fund Manager" },
                    { value:  "Solicitors or other legal professionals", display_value: "Solicitors or other legal professionals" },
                    { value: "Other", display_value: "Other regulated entities – please specify" }
                  ]}
                />

                {
                  (formData.ThirdPartyRelianceType === "Other") && 
                  <Input
                  isReport={isReport}
                    label="Specify other regulated entity"
                    required={true}
                    name="otherRegulatedEntity"
                    value={formData.otherRegulatedEntity}
                    disabled={isReadOnly}
                    onChange={handleChange}
                  />
                }

                <Select 
                  label="Which regulatory body is the entity authorised by?"
                  name="regulatoryBodyAutorizedBy"
                  value={formData.regulatoryBodyAutorizedBy}
                  onChange={handleChange}
                  required={true}
                  disabled={isReadOnly}
                  isReport={isReport}
                  options={[
                    { value: "FCA", display_value: "FCA (Financial Conduct Authority)" },
                    { value: "HMRC", display_value: "HMRC (for estate agents, trust or company service providers, etc.)" },
                    { value: "Solicitors Regulation Authority", display_value: "Solicitors Regulation Authority" },
                    { value: "ICAEW", display_value: "ICAEW (Institute of Chartered Accountants)" },
                    { value: "SEC", display_value: "SEC (Securities and Exchange Commission)" },
                    { value: "JFSC", display_value: "JFSC (Jersey Financial Services Commission)" },
                    { value: "Other", display_value: "Other regulatory body – please specify" }
                  ]}
                />

                {
                  (formData.regulatoryBodyAutorizedBy === "Other") && 
                  <Input
                    label="Specify other regulated Body"
                    required={true}
                    name="otherRegulatoryBody"
                    isReport={isReport}
                    value={formData.otherRegulatoryBody}
                    disabled={isReadOnly}
                    onChange={handleChange}
                  />
                }

              </div>

            )}
            </div>
            </form>

            {showGuarantorModal && (
              <div className="modal" style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 10 }}>
                <div className="modal-content" style={{ background: "white", padding: "20px", borderRadius: "8px", textAlign: "center", maxWidth: "500px" }}>
                  <h2 style={{ margin: "10px 0" }}>Guarantor Selected</h2>
                  <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    <p>It is highly suggested that you run a search on the guarantor and add the results to the optional attachments.</p>
                    <label style={{ display: "block", marginTop: "12px", marginBottom: "6px", fontWeight: "500" }}>
                      Provide Brief Details *
                    </label>
                    <textarea
                      name="guarantorBriefDetails"
                      value={formData.guarantorBriefDetails || ""}
                      onChange={handleChange}
                      disabled={isReadOnly}
                      rows="4"
                      placeholder="Provide brief details about the guarantor..."
                      style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", resize: "vertical", fontWeight: "normal" }}
                    />
                  </div>
                  <div style={{ marginTop: "16px", display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button
                      onClick={() => { handleUpdate(); setShowGuarantorModal(false); }}
                      style={{ padding: "8px 16px", border: "none", background: "#07b1b0", color: "white", borderRadius: "4px", cursor: "pointer" }}
                    >
                      Save
                    </button>
                    <button
                      onClick={() => setShowGuarantorModal(false)}
                      style={{ padding: "8px 16px", border: "1px solid #ccc", background: "white", color: "#333", borderRadius: "4px", cursor: "pointer" }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
    )
}